(() => {
  const number = String.raw`\$?(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?`;
  const value = `${number}%?`;
  const arithmetic = new RegExp(`^${value}(?:\\s*\\\\times\\s*${value})?(?:\\s*[+−-]\\s*${value}(?:\\s*\\\\times\\s*${value})?)*$`);
  const measurement = new RegExp(`^(?:[<>≤≥]\\s*)?${number}(?:\\s*[-–−]\\s*${number})?\\s*\\\\text\\{\\s*cm\\s*\\}$`);
  const excluded = 'a, script, style, code, pre, textarea, [contenteditable], .cx-inline-formula';

  function format(source) {
    const expression = source.trim();
    if (!expression || expression.length > 160) return null;
    if (arithmetic.test(expression)) return expression.replace(/\s*\\times\s*/g, ' × ');
    if (measurement.test(expression)) return expression.replace(/\\text\{\s*cm\s*\}/, ' cm');
    return null;
  }

  function enhance(scope) {
    const contents = Array.from(scope.querySelectorAll('.article-template__content'));
    if (scope.matches?.('.article-template__content')) contents.unshift(scope);
    contents.forEach((content) => {
      const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.nodeValue.includes('\\(') && node.parentElement && !node.parentElement.closest(excluded)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        },
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const original = node.nodeValue;
        const fragment = document.createDocumentFragment();
        const expressions = original.matchAll(/\\\(([\s\S]*?)\\\)/g);
        let cursor = 0;
        for (const match of expressions) {
          const formatted = format(match[1]);
          if (formatted === null) continue;
          fragment.append(document.createTextNode(original.slice(cursor, match.index)));
          const inline = document.createElement('span');
          inline.className = 'cx-inline-formula';
          inline.dataset.cxFormulaSource = match[0];
          inline.textContent = formatted;
          fragment.append(inline);
          cursor = match.index + match[0].length;
        }
        if (!cursor) return;
        fragment.append(document.createTextNode(original.slice(cursor)));
        node.replaceWith(fragment);
      });
    });
  }

  enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
